import { HomeSectionContainer } from '../../../Pages/Home/Home.styled';
import styled from 'styled-components';

export const DealsOffersContainer = styled(HomeSectionContainer)`
	padding: 60px 0px 100px 0px;
	background: #f2f5f5;
`;

export const DealsOffersContentBody = styled.div`
	display: block;
	position: relative;
	z-index: 1;
	margin-left: 15px;
`;

export const DealsOffersContentNav = styled.div`
	margin-top: 10px;
	text-align: center;
`;
